module.exports = __webpack_public_path__ + "1e7892227286bddc889ed66c71863ce9.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/opensans-npm-webfont/fonts/opensanssemibolditalic.woff2
// module id = 696
// module chunks = 57